import { render, staticRenderFns } from "./RegistrationsOverTime.vue?vue&type=template&id=f0f6053c&scoped=true&"
import script from "./RegistrationsOverTime.vue?vue&type=script&lang=js&"
export * from "./RegistrationsOverTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f6053c",
  null
  
)

export default component.exports